export class JobGateJobAlert{
    Id:number;
    UserId:number;
    JobGateId:string;
    JobTitle:string;
    SearchKeyWord:string;
    JobGateSectorIds:string;
    JobGateEmploymentTypeId:string;
    LocationText:string;
    PostCode:string;
    IsOk : boolean;
    IsDeletedFromJobGate: boolean;   
    EmailConsent : boolean; 
}